import classNames from "classnames";
import React, { FC } from "react";

type PropTypes = {
  className?: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "blue" | "orange" | "red";
  color?: "green" | "red" | "orange" | "blue" | "violet" | "gray";
  size?: "small" | "basic";
  isLoading?: boolean;
};

const InfoCardSkeleton: FC<{ size: "small" | "basic" }> = ({ size }) => (
  <div className={classNames("info-card__skeleton")} aria-hidden>
    <span className="info-card__skeleton-line info-card__skeleton-line--title" />
    <span className="info-card__skeleton-line info-card__skeleton-line--desc" />
  </div>
);

const InfoCard: FC<PropTypes> = ({
  children,
  color = "gray",
  variant = "primary",
  size = "basic",
  className,
  isLoading,
}) => {
  return (
    <div
      className={classNames(
        "info-card",
        `info-card__size-${size}`,
        `info-card__color-${color}`,
        `info-card__variant-${variant}`,
        className,
        { "info-card__loading": isLoading },
      )}
      aria-busy={isLoading || undefined}
    >
      {isLoading ? <InfoCardSkeleton size={size} /> : children}
    </div>
  );
};

export default InfoCard;
